export default __webpack_public_path__ + "static/media/pizza.a085d9c0.svg";